import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionImageEnhancer from '../../../redux/action/FJActionImageEnhancer';
import FJImageEnhancerFileList from './FJImageEnhancerFileList';

const FJImageEnhancerFileListContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const uploadImageList = useSelector(state => state.imageEnhancer.uploadImageList);
    const upscale = useSelector(state => state.imageEnhancer.upscale);

    const deleteImage = item => {
        dispatch(FJActionImageEnhancer.deleteImageFile(item));
    };
    return <FJImageEnhancerFileList deleteImage={deleteImage} uploadImageList={uploadImageList} upscale={upscale} />;
};

export default FJImageEnhancerFileListContainer;
